import React, { forwardRef, useMemo, useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';
import styled from 'styled-components';
import { FieldContainer } from './FieldContainer';
import FunPlaceholder from './FunPlaceholder';

const getRandomId = () => uuid();
interface SelectFieldProps {
  error?: boolean | string;
  label?: string;
  onBlur?: (currentValue: string) => void;
  onChange?: (value: string) => void;
  placeholder?: string;
  funPlaceholder?: boolean;
  value?: string;
  options: any;
  name: string;
}

const SelectFieldContainer = styled.div.withConfig({ componentId: 'sc-1kmnpj3-0' })`
  select {
    height: 58px;
    border-radius: unset;
    font-size: 18px;
    box-sizing: border-box;
    display: inline-block;
    -webkit-text-decoration: none;
    text-decoration: none;
    outline: 0;
    overflow: hidden;
    color: #313131;
    line-height: 24px;
    width: 100%;
    background-color: transparent;
    border: none;
    font-family: Circular-Pro-Book-S, Roboto, sans-serif;
    padding: 24px 10px 10px 20px;
    appearance: none;
  }
`;

const SelectFunPlaceholder = styled(FunPlaceholder).withConfig({ componentId: 'sc-1kmnpj3-1' })`
  z-index: -1;
`;

const SelectField = forwardRef(function SelectField(
  {
    error,
    label,
    onBlur,
    onChange,
    placeholder,
    funPlaceholder = true,
    value = '',
    options = [],
    name,
  }: SelectFieldProps,
  ref: React.Ref<HTMLSelectElement>
) {
  const id = useMemo(getRandomId, []);
  const [selectedValue, setSelectedValue] = useState<string>(value);

  const handleOnChange = (e: any) => {
    const { value } = e.target;
    onChange?.(value);
    setSelectedValue(value);
  };

  const inputRef = useRef<HTMLDivElement>(null);

  const focusInput = () => {
    inputRef?.current?.querySelector('select')?.click();
  };

  return (
    <FieldContainer error={!!error}>
      <SelectFieldContainer onClick={focusInput}>
        {!!label && !funPlaceholder && (
          <label aria-label={label} htmlFor={id}>
            {label}
          </label>
        )}
        <div>
          {funPlaceholder && !!placeholder && (
            <SelectFunPlaceholder
              error={!!error}
              shrink={!!selectedValue?.length}
              text={placeholder}
            />
          )}
        </div>
        <select
          id={id}
          name={name}
          onBlur={(e) => onBlur?.(e.target.value)}
          onChange={handleOnChange}
          ref={ref}
          value={selectedValue}
        >
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <option value=""></option>
          {options.map((opt: any) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </SelectFieldContainer>
    </FieldContainer>
  );
});

export default SelectField;
